<section *ngIf="stateToDisplay">
  <ng-container *ngIf="stateToDisplay === subscriptionState.active">
    <tr-icon
      [icon]="icon.circle"
      [size]="iconSize.minuscule"
      [color]="iconColor.green"
      class="circle"
    ></tr-icon>

    <p class="color-accent">Active</p>
  </ng-container>

  <ng-container *ngIf="stateToDisplay !== subscriptionState.active">
    <span>{{ stateToDisplay | capitalize }}</span>
  </ng-container>
</section>
